export enum ComponentId {
  INCIDENT_DAMAGE_DESCRIPTION = "description",
  INCIDENT_DAMAGE_BACK_IMAGE = "backImage",
  INCIDENT_DAMAGE_FRONT_IMAGE = "frontImage",
  INCIDENT_DAMAGE_IMAGES = "damages",
  INCIDENT_DAMAGE_ADDITIONAL_IMAGES = "damages",
}
